export interface AdvertViewContactSellerDTO {
  makeName: string;
  modelName: string;
  plateName: string;
}
